import { type ComponentPropsWithoutRef, memo } from 'react';
import { useSelector } from 'react-redux';

import { cn } from '@air/utils-tailwind';

import { contentCollectionFormDescriptionSelector, contentCollectionFormTitleSelector } from '../redux';

export type ContentCollectionSidebarHeaderProps = ComponentPropsWithoutRef<'header'>;

export const ContentCollectionSidebarHeader = memo(
  ({ className, ...restOfProps }: ContentCollectionSidebarHeaderProps) => {
    const title = useSelector(contentCollectionFormTitleSelector);
    const description = useSelector(contentCollectionFormDescriptionSelector);

    return (
      <header className={cn('flex flex-col gap-3 text-center md:text-left', className)} {...restOfProps}>
        <h1
          className="font-semibold ads:text-primary text-24 text-gray-12"
          data-testid="CONTENT_COLLECTION_SIDEBAR_HEADER_TITLE"
        >
          {title}
        </h1>
        {description && (
          <p
            className="ads:text-metadata text-16 text-gray-10"
            data-testid="CONTENT_COLLECTION_SIDEBAR_HEADER_DESCRIPTION"
          >
            {description}
          </p>
        )}
      </header>
    );
  },
);

ContentCollectionSidebarHeader.displayName = 'ContentCollectionSidebarHeader';
